module.exports = __webpack_public_path__ + "static/03-soil-data-20fc63cd5705915ae6a199e1f198dca5.png";